import { apiClient } from './apiClient'
import { RemoteConfigValue } from '../../types/remoteConfig'
import { logger } from '../../utils/logger'
import { getRemoteConfig, getValue as getFirebaseValue, fetchAndActivate } from 'firebase/remote-config'
import { app } from '../../config/firebase'

// Initialize Remote Config
const remoteConfig = getRemoteConfig(app)

// Set minimum fetch interval for development
remoteConfig.settings.minimumFetchIntervalMillis = 3600000 // 1 hour

export class RemoteConfigService {
  /**
   * Get a remote config value by key using Firebase Remote Config
   */
  static async getValue(key: string): Promise<RemoteConfigValue | null> {
    try {
      logger.log(`📦 Fetching remote config value for key: ${key}`)
      
      // Fetch and activate latest config
      await fetchAndActivate(remoteConfig)
      
      // Get value from Firebase Remote Config
      const value = getFirebaseValue(remoteConfig, key)
      const stringValue = value.asString()
      
      logger.log('✅ Remote config value received:', stringValue)
      
      return {
        key,
        value: stringValue
      }
    } catch (error) {
      logger.error(`Error fetching remote config value for key ${key}:`, error)
      return null
    }
  }

  /**
   * Update a remote config value via backend API
   */
  static async updateValue(key: string, value: string): Promise<RemoteConfigValue> {
    logger.log(`📝 Updating remote config value for key: ${key}`)
    
    // Use the format expected by the backend
    const response = await apiClient.put('/v1/remote-config', {
      params: {
        [key]: value
      },
      description: 'Updated via backoffice'
    })
    
    logger.log('✅ Remote config value updated:', response)
    
    return {
      key,
      value,
      updatedAt: new Date().toISOString()
    }
  }
}